var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconXls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 12,
    fill: "#107C41"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 12C10 10.3431 11.3431 9 13 9H21.1716C21.702 9 22.2107 9.21071 22.5858 9.58579L27.4142 14.4142C27.7893 14.7893 28 15.298 28 15.8284V26C28 27.6569 26.6569 29 25 29H13C11.3431 29 10 27.6569 10 26V12ZM21 11L26 16H22C21.4477 16 21 15.5523 21 15V11ZM12.25 19C12.25 18.5858 12.5858 18.25 13 18.25H17C17.4142 18.25 17.75 18.5858 17.75 19C17.75 19.4142 17.4142 19.75 17 19.75H13C12.5858 19.75 12.25 19.4142 12.25 19ZM20.25 19C20.25 18.5858 20.5858 18.25 21 18.25H25C25.4142 18.25 25.75 18.5858 25.75 19C25.75 19.4142 25.4142 19.75 25 19.75H21C20.5858 19.75 20.25 19.4142 20.25 19ZM13 21.25C12.5858 21.25 12.25 21.5858 12.25 22C12.25 22.4142 12.5858 22.75 13 22.75H17C17.4142 22.75 17.75 22.4142 17.75 22C17.75 21.5858 17.4142 21.25 17 21.25H13ZM20.25 22C20.25 21.5858 20.5858 21.25 21 21.25H25C25.4142 21.25 25.75 21.5858 25.75 22C25.75 22.4142 25.4142 22.75 25 22.75H21C20.5858 22.75 20.25 22.4142 20.25 22ZM13 24.25C12.5858 24.25 12.25 24.5858 12.25 25C12.25 25.4142 12.5858 25.75 13 25.75H17C17.4142 25.75 17.75 25.4142 17.75 25C17.75 24.5858 17.4142 24.25 17 24.25H13ZM20.25 25C20.25 24.5858 20.5858 24.25 21 24.25H25C25.4142 24.25 25.75 24.5858 25.75 25C25.75 25.4142 25.4142 25.75 25 25.75H21C20.5858 25.75 20.25 25.4142 20.25 25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconXls);
export default __webpack_public_path__ + "static/media/icon_xls.fb525f27fb154d8f2486cd84fb408ec4.svg";
export { ForwardRef as ReactComponent };